export default __webpack_public_path__ + "static/media/FECHAS_06.79a449ea.png";